import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { RequestReasonDto, RequestReasonStore } from '../../stores/configuration/events-n-requests/request-reasons-store';
import { nameof } from '../../utils/object';
import { ItemReference, QueryResult } from '../../stores/dataStore';
import { isNullOrWhiteSpaces } from '../../utils/useful-functions';
import { TailwindSelectionInput } from '../../widgets/form/selection-input-tw';

interface TailwindRequestReasonEditorProps extends WithTranslation {
  value: ItemReference;
  onChange?: (value: ItemReference) => void;
  onSelected?: (requestReason: RequestReasonDto) => void;
  requestReasons?: RequestReasonStore;
  nullable?: boolean;
  minWidth?: number;
  reloadOnChange?: boolean;
  className?: string;
  placeholder?: string;
  clearable?: boolean;
  readOnly?: boolean;
  filterEventTypeId?: string;
}

interface TailwindRequestReasonEditorState {
  query?: (searchQuery: string) => Promise<QueryResult<ItemReference>>;
}

@connect(['requestReasons', RequestReasonStore])
class TailwindRequestReasonEditor extends React.Component<TailwindRequestReasonEditorProps, TailwindRequestReasonEditorState> {
  private get requestReasonsStore() {
    return this.props.requestReasons;
  }

  constructor(props: TailwindRequestReasonEditorProps) {
    super(props);

    this.state = {
      query: this.getRequestReasons()
    };
  }

  @autobind
  private getRequestReasons() {
    const method = async (search: string) => {
      const filter = [];
      if (!isNullOrWhiteSpaces(search)) {
        filter.push(`startswith(tolower(${nameof<RequestReasonDto>('name')}), '${search.toLowerCase()}')`);
      }

      if (this.props.filterEventTypeId) {
        filter.push(`EventTypesIds ne null and EventTypesIds/IdWords/any(id:(id eq ${this.props.filterEventTypeId}))`);
      }

      const result = await this.requestReasonsStore.getAllAsync({
        searchQuery: '',
        skip: 0,
        take: 100000,
        orderBy: [{ direction: 'Ascending', field: nameof<RequestReasonDto>('name'), useProfile: false }],
        filter
      });

      return Object.assign({}, result, { items: result.items.map(c => ({ id: c.id, title: c.name })) }) as QueryResult<ItemReference>;
    };
    return method;
  }

  @autobind
  private onChange(value: ItemReference) {
    if (this.props.onChange) this.props.onChange(value);
    if (this.props.onSelected) {
      if (value) {
        let requestReasonSelected = this.requestReasonsStore.state.items.first(item => item.item.id === value.id).item;
        this.props.onSelected(requestReasonSelected);
      } else {
        this.props.onSelected(null);
      }
    }
  }

  public render() {
    const query = this.state.query;
    return (
      <TailwindSelectionInput
        content={item => <div>{item.title}</div>}
        className={this.props.className}
        searchable
        readOnly={this.props.readOnly}
        minWidth={this.props.minWidth}
        nullable={this.props.nullable}
        placeholder={this.props.placeholder}
        query={query}
        value={this.props.value}
        onChange={this.onChange}
        clearable={this.props.clearable}
      />
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(TailwindRequestReasonEditor);
